import RegexUtils from './RegexUtils';
import BitsyApollo from './BitsyApollo';
import FormInputUtils from './FormInputUtils';

export function handleChange(event, state) {
  const newState = JSON.parse(JSON.stringify(state));
  const { isSignIn } = newState;
  if (state.userExistsError) newState.userExistsError = '';
  if (state.unknownError) newState.unknownError = '';
  if (state.userNotFoundError) newState.userNotFoundError = '';
  if (state.termsAndConditionsError) {
    newState.termsAndConditionsError = '';
  }

  const formItemToChange = event.target.name;
  let newValue = event.target.value;

  if (formItemToChange === 'phoneNumber') {
    newValue = FormInputUtils.formatPhoneInputAndSetCursorPosition(
      event.target,
    );
  }
  newState.signInSignUpValues[formItemToChange] = newValue;

  // Validation state handler
  if (formItemToChange === 'firstName' || formItemToChange === 'lastName') {
    newState.signInSignUpValidationState[
      formItemToChange
    ] = RegexUtils.hasLengthAndNoSymbols(newValue);
  } else if (formItemToChange === 'email') {
    newState.signInSignUpValidationState[formItemToChange] = RegexUtils.isEmail(
      newValue,
    );
  } else if (formItemToChange === 'password') {
    newState.signInSignUpValidationState[formItemToChange] = isSignIn
      ? RegexUtils.isLessSecurePassword(newValue)
      : RegexUtils.isPassword(newValue);
  } else if (formItemToChange === 'phoneNumber') {
    newState.signInSignUpValidationState[
      formItemToChange
    ] = RegexUtils.isPhoneNumber(newValue.replace(/\D/g, ''), true);
  }
  return newState;
}

export function updateFormValidity(state) {
  let isValid = true;
  if (
    !state.isSignIn &&
    !Object.values(state.signInSignUpValidationState).reduce(
      (acc, newToCheck) => acc && newToCheck,
    )
  ) {
    isValid = false;
  }
  if (
    state.isSignIn &&
    (!state.signInSignUpValues.email || !state.signInSignUpValues.password)
  ) {
    isValid = false;
  }
  if (
    !state.isSignIn &&
    !state.signInSignUpValues.isAgreedToTermsAndConditions
  ) {
    return {
      isValid: false,
      termsAndConditionsError: 'Please agree to terms and conditions',
    };
  }
  return { isValid };
}

export function handleSignInOrSignUpSubmit(state) {
  if (state.isSignIn) {
    return BitsyApollo.signInUser(state.signInSignUpValues);
  }
  const { companyCode } = state;
  const signUpData = {
    ...state.signInSignUpValues,
    companyCode,
  };
  if (state.isSmsOptInSelected) {
    signUpData.isOptedInSMS = true;
  }
  return BitsyApollo.signUpUser(signUpData);
}

export function handleSignInOrSignUpError(error) {
  if (error.key === 'USER_EXISTS') {
    return {
      userExistsError: 'User already exists with that email.',
      isLoading: false,
    };
  }
  if (error.key === 'INVALID') {
    return {
      userNotFoundError: 'Incorrect username or password',
      isLoading: false,
    };
  }
  if (error.key === 'LEGACY_ACCOUNT_RESET_PASSWORD_NEW') {
    return {
      userNotFoundError: error.value,
      isLoading: false,
    };
  }
  if (error.key === 'LEGACY_ACCOUNT_RESET_PASSWORD_COMBINED') {
    return {
      userNotFoundError: error.value,
      isLoading: false,
    };
  }
  if (error.key === 'DENIED') {
    return {
      userNotFoundError: error.value,
      isLoading: false,
    };
  }
  if (error.value) {
    return { unknownError: error.value, isLoading: false };
  }
  return {
    unknownError: 'Something went wrong, please try again later.',
    isLoading: false,
  };
}

export default {
  handleChange,
  updateFormValidity,
  handleSignInOrSignUpSubmit,
  handleSignInOrSignUpError,
};
